<template>
    <div class="navbar">
        <img src="https://cdn.gemeindeplaner.at/pv-wimsbach/arrow_left.png" class="prevButton" @click="previousSlide()">
        <h1>Photovoltaik Anlage Visualisierung</h1>
        <img src="https://cdn.gemeindeplaner.at/pv-wimsbach/arrow_right.png" class="nextButton" @click="nextSlide()">
    </div>
</template>

<script>
    export default {
        name: 'Navbar',
        components: {},
        props: {},
        methods: {
            nextSlide () {
                // Clicks the next button of the carousel
                document.querySelector('span.next').click();
            },
            previousSlide () {
                // Clicks the prev button of the carousel
                document.querySelector('span.prev').click();
            },
        },
    };
</script>

<style scoped>
    .navbar {
        height: 100px;
        border-bottom: 1px solid #fff;
        margin: 0 5px;
    }
    .navbar h1 {
        margin-top: 20px;
    }
    img {
        width: 80px;
        cursor: pointer;
    }
</style>
